import _ from "lodash";

import ExternalLogger from "../logger/ExternalLogger";

const GroupService = function ($q, accountService, groupFactory) {
    const logger = ExternalLogger.getInstance("GroupService");

    const service = {};

    //Caching - Map that stores the indicators by group id
    const fevaValuesMap = {};
    //Indicator to determine if all groups have been checked for FEVA
    let allGroupsChecked = false;

    service.isSubjectToFEVA = function () {
        //Get the active group account
        const groupId = accountService.getActiveGroupAccount().groupId;
        const fevaInd = null;
        const deferred = $q.defer();

        //check if the active group account is in the cache
        const groupIndicator = _.find(fevaValuesMap, function (value, key) {
            return key === groupId;
        });

        //if value not in the map then call REST service
        if (groupIndicator) {
            deferred.resolve(groupIndicator);
        } else {
            service.callRESTService(groupId, deferred);
        }
        return deferred.promise;
    };

    service.isAnyGroupSubjectToFEVA = function () {
        //on the profile page, we need to check
        //if any of the plans are subject to FEVA
        const deferred = $q.defer();

        //are there any plans subject to FEVA in the cache
        const groupIndicator = _.find(fevaValuesMap, function (value, key) {
            return value === true;
        });

        if (groupIndicator) {
            deferred.resolve(true);
        } else {
            if (allGroupsChecked) {
                deferred.resolve(false);
            } else {
                service.callRESTService(null, deferred);
            }
        }

        return deferred.promise;
    };

    service.callRESTService = function (groupId, deferred) {
        groupFactory.isSubjectToFEVA(groupId).then(
            function success(response) {
                //populate the cache using the rest response
                _.each(response.indicators, function (item) {
                    fevaValuesMap[item.groupId] = item.indicator;
                });
                let foundGroupSubjectToFEVA = false;
                //are there any plans subject to FEVA in the cache
                const groupIndicator = _.find(fevaValuesMap, function (value, key) {
                    return value === true;
                });
                if (groupIndicator) {
                    foundGroupSubjectToFEVA = true;
                }
                if (groupId === null) {
                    allGroupsChecked = true;
                }
                deferred.resolve(foundGroupSubjectToFEVA);
            },
            function error(message) {
                deferred.resolve(false);
                logger.error(
                    "ERROR - groupFactory.isSubjectToFEVA(groupId): retrieving isSubjectToFEVA:" +
                        message
                );
            }
        );
    };

    return service;
};

GroupService.$inject = ["$q", "accountService", "groupFactory"];
export default GroupService;
